import {
  formatBRL,
  formatPlainDateBR,
  parseMoney,
  plainDate,
  todayInAppZone,
} from '@financas/shared';
import type { AccountType } from './api';

/**
 * Apresentacao. As funcoes de calculo ficam em @financas/shared; aqui so mora
 * o que e especifico de tela.
 */

/** Centavos chegam da API como texto; a formatacao volta a passar por bigint. */
export function money(cents: string, options?: { signDisplay?: 'auto' | 'never' }): string {
  return formatBRL(BigInt(cents), options);
}

/** Valor absoluto — para listas onde a cor ja indica entrada ou saida. */
export function absMoney(cents: string): string {
  const value = BigInt(cents);
  return formatBRL(value < 0n ? -value : value);
}

export function dateBR(isoDate: string): string {
  return formatPlainDateBR(plainDate(isoDate));
}

export function today(): string {
  return todayInAppZone();
}

/** Converte o que o usuario digitou em centavos, aceitando o formato brasileiro. */
export function parseAmountInput(value: string): bigint {
  return parseMoney(value);
}

export const ACCOUNT_TYPE_LABELS: Record<AccountType, string> = {
  CHECKING: 'Conta corrente',
  SAVINGS: 'Poupanca',
  PAYMENT: 'Conta de pagamento',
  CASH: 'Dinheiro',
  INVESTMENT: 'Investimento',
  CREDIT_CARD: 'Cartao de credito',
};

export const ACCOUNT_TYPE_ORDER: AccountType[] = [
  'CHECKING',
  'SAVINGS',
  'PAYMENT',
  'CASH',
  'INVESTMENT',
  'CREDIT_CARD',
];

export const INVOICE_STATUS_LABELS: Record<string, string> = {
  OPEN: 'Aberta',
  CLOSED: 'Fechada',
  PAID: 'Paga',
};

/** Mes corrente no formato AAAA-MM, no fuso da aplicacao. */
export function currentMonth(): string {
  return todayInAppZone().slice(0, 7);
}

export function monthLabel(month: string): string {
  const [year, monthPart] = month.split('-');
  const date = new Date(Date.UTC(Number(year), Number(monthPart) - 1, 1));
  const formatted = new Intl.DateTimeFormat('pt-BR', {
    timeZone: 'UTC',
    month: 'long',
    year: 'numeric',
  }).format(date);
  return formatted.charAt(0).toUpperCase() + formatted.slice(1);
}

export function shiftMonth(month: string, delta: number): string {
  const [year, monthPart] = month.split('-');
  const total = Number(year) * 12 + (Number(monthPart) - 1) + delta;
  const nextYear = Math.floor(total / 12);
  const nextMonth = (total % 12) + 1;
  return `${nextYear}-${String(nextMonth).padStart(2, '0')}`;
}

/**
 * Classe CSS do valor, pelo SINAL e so por ele.
 *
 * Transferencia era pintada de cinza aqui, com o argumento de que mover
 * dinheiro entre contas proprias nao e ganho nem perda. O argumento vale para
 * a SOMA do mes — e la ela continua fora —, mas na linha do extrato ela vira
 * um numero de cor diferente de todos os outros, e quem confere passa a
 * precisar lembrar de uma excecao. A coluna da categoria ja diz que aquilo e
 * transferencia; a cor so precisa dizer para que lado o dinheiro andou.
 */
export function amountClass(cents: string): string {
  const valor = BigInt(cents);
  if (valor < 0n) return 'expense';
  if (valor > 0n) return 'income';
  return 'muted';
}
